export const GET_SUPPLIERS_COUNTRIES_START =
  'GET_SUPPLIERS_COUNTRIES_START';
export const GET_SUPPLIERS_COUNTRIES_SUCCESS =
  'GET_SUPPLIERS_COUNTRIES_SUCCESS';
export const GET_SUPPLIERS_COUNTRIES_ERROR =
  'GET_SUPPLIERS_COUNTRIES_ERROR';
export const GET_SUPPLIERS_COUNTRIES_END =
  'GET_SUPPLIERS_COUNTRIES_END';
